export const TEST = 'TEST';
export const SET_TOKEN_STATUS = 'SET_TOKEN_STATUS';
export const SET_AUTHORIZATION_STATUS = 'SET_AUTHORIZATION_STATUS';

export const REGISTRATION_STARTED = 'REGISTRATION_STARTED';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
export const REGISTRATION_FAILURE = 'REGISTRATION_FAILURE';

export const LOGIN_STARTED = 'LOGIN_STARTED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const SET_INVITATION_CODE_STARTED = 'SET_INVITATION_CODE_STARTED';
export const SET_INVITATION_CODE_SUCCESS = 'SET_INVITATION_CODE_SUCCESS';
export const SET_INVITATION_CODE_FAILURE = 'SET_INVITATION_CODE_FAILURE';

export const LOGOUT_STARTED = 'LOGOUT_STARTED';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const RESEND_EMAIL_STARTED = 'RESEND_EMAIL_STARTED';
export const RESEND_EMAIL_SUCCESS = 'RESEND_EMAIL_SUCCESS';
export const RESEND_EMAIL_FAILURE = 'RESEND_EMAIL_FAILURE';

export const FORGOT_PASSWORD_STARTED = 'FORGOT_PASSWORD_STARTED';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

export const RESET_PASSWORD_STARTED = 'RESET_PASSWORD_STARTED';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const LOGIN_2FA_REQUIRED = 'LOGIN_2FA_REQUIRED';

export const LOGIN_2FA_VERIFY_STARTED = 'LOGIN_2FA_VERIFY_STARTED';
export const LOGIN_2FA_VERIFY_SUCCESS = 'LOGIN_2FA_VERIFY_SUCCESS';
export const LOGIN_2FA_VERIFY_FAILURE = 'LOGIN_2FA_VERIFY_FAILURE';

export const LOGIN_2FA_RESET = 'LOGIN_2FA_RESET';








